import React from "react";
// import "../Assests/Styles/Donate.scss";
import AccountDetails from "../Assessts/Images/AccountDetails.png";
const Donate = () => {
    return (<>
        <div className="Web-MainHeading mt-3">Donate</div>
        <div className="Donate-Details dflex w-100 alignitems p-4 JSAround" >

            <div className=" dflex flexd-column alignitems gap-2" style={{alignItems:"flex-start"}}>
                <span className="Web-SubHeading mb-2">NORTH SOUTH FOUNDATION</span>
                <span className="mb-2">please donate to help us achieve our mission of making every child future ready.</span>
                <span><b>Account Number:</b> 50100800458399</span>
                <span><b>IFSC Code:</b> HDFC0003817</span>
                <span><b>BRANCH:</b> HDFC Bank, Jubilee hills branch, Hyderabad, Telangana</span>
            </div>
            <img src={AccountDetails} alt="Account Details" />
        </div>
    </>)
}
export default Donate;